import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS, mailtoHref } from "../data/site";

const SOCIALS = [
    { label: "Instagram", key: "instagram", href: BRAND.socials.instagram },
    { label: "Pinterest", key: "pinterest", href: BRAND.socials.pinterest },
    { label: "Facebook", key: "facebook", href: BRAND.socials.facebook },
    { label: "YouTube", key: "youtube", href: BRAND.socials.youtube },
];

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#dddddd] bg-white"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    {/* Brand block */}
                    <div className="md:col-span-5">
                        <Link
                            to="/"
                            className="font-serif text-4xl md:text-5xl text-[#111111] leading-none"
                        >
                            Pixemance<span className="text-[#444444]">.</span>
                        </Link>
                        <p className="mt-6 text-[#444444] text-base max-w-md leading-relaxed">
                            Business-First Digital Presence & Performance.
                            Quietly considered systems for businesses that take
                            their reputation seriously.
                        </p>
                    </div>

                    {/* Nav */}
                    <div className="md:col-span-3">
                        <p className="eyebrow">Navigate</p>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <Link
                                        to={l.href}
                                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                                        className="text-[15px] text-[#111111] link-underline"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/contact"
                                    data-testid="footer-link-contact"
                                    className="text-[15px] text-[#111111] link-underline"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-4">
                        <p className="eyebrow">Talk to Pixemance</p>
                        <ul className="mt-5 space-y-3 text-[15px]">
                            <li>
                                <a
                                    data-testid="footer-email"
                                    href={mailtoHref(
                                        "Hello Pixemance — enquiry from the website",
                                    )}
                                    className="link-underline text-[#111111]"
                                >
                                    {BRAND.email}
                                </a>
                            </li>
                            <li className="text-[#444444]">
                                {BRAND.location}
                            </li>
                        </ul>

                        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-[13px] tracking-wide text-[#444444]">
                            {SOCIALS.map((s) => (
                                <a
                                    key={s.key}
                                    href={s.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="link-underline"
                                    data-testid={`footer-social-${s.key}`}
                                >
                                    {s.label}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#dddddd] flex flex-col md:flex-row gap-4 md:items-end md:justify-between">
                    <p className="text-xs tracking-[0.25em] uppercase text-[#444444]">
                        © {year} {BRAND.name}. All rights reserved.
                    </p>
                    <p className="font-serif italic text-[#444444] text-lg leading-none">
                        Where design meets performance.
                    </p>
                </div>
            </div>
        </footer>
    );
};
